// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width: 480px) {\n  .modalView {\n    margin-bottom: 340px;\n  }\n}", "",{"version":3,"sources":["webpack://./src/components/LoginModal.scss"],"names":[],"mappings":"AAAA;EACE;IACE,oBAAA;EACF;AACF","sourcesContent":["@media screen and (max-width: 480px) {\n  .modalView {\n    margin-bottom: 340px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
